import { useState } from 'react';

// TODO: Update to useMutation later
export const useInitSeekAd = () => {
  const [jsonResponse, setJsonResponse] = useState({});

  const mutate = async (jobId: string | null, seekAccountId?: number) => {
    const param = seekAccountId ? { seek_account_id: seekAccountId } : {};
    try {
      const response = await fetch(`/api/v4/seek/jobs/${jobId}/job_ads/init_seek_ad`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(param)
      });
      const json = await response.json();
      setJsonResponse(json);
    } catch (exception) {
      console.log(exception);
    }
  };

  const reset = () => {
    setJsonResponse({});
  };

  return { mutate, jsonResponse, reset };
};
